import { useEffect, useRef } from 'react';
import { Button } from '@airdao/ui-library';
import { BigNumber, utils } from 'ethers';

import NumericalInput from './NumericalInput';
import kosmosIcon from '../../../assets/icons/kosmos.svg';
import { InfoDataProps, RewardsStateProps } from '../../../hooks/types';
import useStakeActionHandler from '../../../hooks/useStakeActionHandler';
import formatPercent from '../../../utils/formatPercent';

import { useFormatter, NumberType } from '../../../utils/formatNumbers';

const StakeTabPanel = ({
  stateRewards,
  state,
}: {
  stateRewards: RewardsStateProps;
  state: {
    data: InfoDataProps;
    fetchData: () => void;
  };
}) => {
  const { data } = state;
  const { stakingTokenBalance, rewardParams } = data;
  const { getTier } = stateRewards;
  const inputRef = useRef<HTMLInputElement>(null);
  const { formatNumberOrString } = useFormatter();

  const {
    userInput,
    isLoading,
    handleDisabled,
    handleMaxInput,
    onClickHandler,
  } = useStakeActionHandler(true, 'stakingLock', state);

  const { value, onUserInput } = userInput;

  const rewardAPY = BigNumber.from(getTier.level).isZero()
    ? '10%'
    : formatPercent(rewardParams.rewardAPY);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <NumericalInput
        prependSymbol={
          <div className="prepend">
            <img src={kosmosIcon} alt="kosmos" />
            <span className="prepend__label">KOS</span>
          </div>
        }
        label="Amount"
        value={value}
        onUserInput={onUserInput}
        ref={inputRef}
      />
      <span className="info-text">
        Balance:{' '}
        {formatNumberOrString({
          input: utils.formatUnits(stakingTokenBalance, 18),
          type: NumberType.TokenNonTx,
        })}{' '}
        <button onClick={() => handleMaxInput(stakingTokenBalance)}>Max</button>
      </span>
      <Button
        disabled={handleDisabled(stakingTokenBalance) || isLoading}
        onClick={() => onClickHandler(value)}
        className="tab-button"
        type="primary"
        size="large"
      >
        {isLoading ? 'Transaction in progress...' : `Stake (${rewardAPY}) APY`}
      </Button>
    </>
  );
};

export default StakeTabPanel;
